export const isAdapterConfigUsingDefaultCaching = adapter => {
  return 'getCacheKey' in adapter;
};